import { render, staticRenderFns } from "./CommanderDetail.vue?vue&type=template&id=147abf13&scoped=true&"
import script from "./CommanderDetail.vue?vue&type=script&lang=js&"
export * from "./CommanderDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommanderDetail.vue?vue&type=style&index=0&id=147abf13&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147abf13",
  null
  
)

export default component.exports